import { forwardRef, useId, type InputHTMLAttributes, type TextareaHTMLAttributes } from "react";

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: string;
  error?: string;
}

export const Field = forwardRef<HTMLInputElement, FieldProps>(function Field(
  { label, hint, error, ...rest },
  ref,
) {
  const id = useId();
  return (
    <div className="bd-field">
      <label className="bd-field__label" htmlFor={id}>
        {label}
      </label>
      <input ref={ref} id={id} className="bd-input" aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-err` : undefined} {...rest} />
      {error ? (
        <span id={`${id}-err`} className="bd-field__error" role="alert">
          {error}
        </span>
      ) : hint ? (
        <span className="bd-field__hint">{hint}</span>
      ) : null}
    </div>
  );
});

interface TextAreaFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  hint?: string;
}

export const TextAreaField = forwardRef<HTMLTextAreaElement, TextAreaFieldProps>(function TextAreaField(
  { label, hint, ...rest },
  ref,
) {
  const id = useId();
  return (
    <div className="bd-field">
      <label className="bd-field__label" htmlFor={id}>
        {label}
      </label>
      <textarea ref={ref} id={id} className="bd-input" {...rest} />
      {hint && <span className="bd-field__hint">{hint}</span>}
    </div>
  );
});
